export class RegisteredIdTypeModel {

  public identityType: string;
  public identityValue: string;

}
